import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import RoleRoute from './components/RoleRoute';
import Login from './pages/Login';
import RecuperarPassword from './pages/RecuperarPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Planes from './pages/Planes';
import Facturas from './pages/Facturas';
import Pagos from './pages/Pagos';
import Mikrotik from './pages/Mikrotik';
import Configuracion from './pages/Configuracion';
import Reportes from './pages/Reportes';
import PortalLogin from './pages/PortalLogin';
import PortalDashboard from './pages/PortalDashboard';

function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Routes>
        {/* Portal Cliente - sin proteccion */}
        <Route path="/portal/login" element={<PortalLogin />} />
        <Route path="/portal" element={<PortalDashboard />} />

        {/* Login Admin */}
        <Route path="/login" element={<Login />} />
        <Route path="/recuperar-password" element={<RecuperarPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Panel Admin - PROTEGIDO */}
        <Route path="/" element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="clientes" element={<Clientes />} />
          <Route path="planes" element={
            <RoleRoute allowedRoles={['admin', 'operador']}>
              <Planes />
            </RoleRoute>
          } />
          <Route path="facturas" element={
            <RoleRoute allowedRoles={['admin', 'operador']}>
              <Facturas />
            </RoleRoute>
          } />
          <Route path="pagos" element={
            <RoleRoute allowedRoles={['admin', 'operador']}>
              <Pagos />
            </RoleRoute>
          } />
          <Route path="mikrotik" element={
            <RoleRoute allowedRoles={['admin', 'tecnico']}>
              <Mikrotik />
            </RoleRoute>
          } />
          <Route path="reportes" element={
            <RoleRoute allowedRoles={['admin', 'operador']}>
              <Reportes />
            </RoleRoute>
          } />
          <Route path="configuracion" element={
            <RoleRoute allowedRoles={['admin']}>
              <Configuracion />
            </RoleRoute>
          } />
        </Route>
      </Routes>
    </>
  );
}

export default App;
